import type { CsvValue } from '@studeva/csv'
import { CSV_BOM, csvContent } from '@studeva/csv'

function format(headers: string[], data: CsvValue[][]) {
  return new Blob([CSV_BOM, csvContent(headers, data)], { type: 'text/csv;charset=utf-8' })
}

export function downloadCSV(
  fileName: string,
  headers: string[],
  data: CsvValue[][],
) {
  const blob = format(headers, data)
  const fileURL = window.URL.createObjectURL(blob)

  const alink = document.createElement('a')
  alink.href = fileURL
  alink.download = `${fileName}.csv`
  alink.click()
}
